import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@modulor/react';
import Button from '../Button/Button';
import { getDataTestAttrs } from '../../utils/testing-locators';
import {
  SLIDER_ARROW_NEXT,
  SLIDER_ARROW_PREVIOUS,
} from '../../constants/dataTestIds';
import styles from './SliderArrows.module.css';

// Common slider arrow buttons
// Not only for Slider component

const SliderArrows = ({
  prevSlide,
  nextSlide,
  isPrevEnabled,
  isNextEnabled,
  className,
}) => {
  return (
    <div className={classNames(styles.component_ig, className)}>
      <Button
        onClick={prevSlide}
        disabled={!isPrevEnabled}
        className={classNames(styles.button_ig, styles.left_ig)}
        {...getDataTestAttrs(SLIDER_ARROW_PREVIOUS)}
      >
        <Icon name="chevron_left" className={styles.icon_ig} size={48} />
      </Button>

      <Button
        onClick={nextSlide}
        disabled={!isNextEnabled}
        className={classNames(styles.button_ig, styles.right_ig)}
        {...getDataTestAttrs(SLIDER_ARROW_NEXT)}
      >
        <Icon name="chevron_right" className={styles.icon_ig} size={48} />
      </Button>
    </div>
  );
};

SliderArrows.propTypes = {
  prevSlide: PropTypes.func.isRequired,
  nextSlide: PropTypes.func.isRequired,
  isPrevEnabled: PropTypes.bool,
  isNextEnabled: PropTypes.bool,
};

SliderArrows.defaultProps = {
  isPrevEnabled: false,
  isNextEnabled: false,
};

export default SliderArrows;
